export default __webpack_public_path__ + "static/Scroll-Image---House-Demolition-d1efa2e5536d4b0f75fc8afb2a501df0.jpg";